import OrdemServicoListaProdutos from "../../../ordem-servicos/add-ordem-servico/components/ordem-servico-lista-produtos.component";

const OrcamentoServicoListaProdutos = ({
  id,
  setOrcamentoServico,
  produtoList,
  setProdutoList,
  listaOrcamentoServicoProdutos,
  setListaOrcamentoServicoProdutos,
  removerProdutoCadastrado,
  setLoading,
  orcamentoServico,
  orcamentoServicoEntity,
  buscarProdutosSimilares,
  produtosSimilares,
  setProdutosSimilares,
  produto,
  setProduto,
  meioPagamentoSelecionado,
  acrescimoPagamento,
  tabelas,
  setListaOrcamentoServicoPagamentos,
  vendedoresList,
  setVendedoresList,
  usuariosList,
  configuracoes,
  permissaoAlterarVendedor,
  permissaoAlterarValorProduto,
  isProdutoEdit,
  setIsProdutoEdit,
  isFechado,
}) => (
  <OrdemServicoListaProdutos
    isFechado={isFechado}
    id={id}
    setOrdemServico={setOrcamentoServico}
    produtoList={produtoList}
    setProdutoList={setProdutoList}
    listaOrdemServicoProdutos={listaOrcamentoServicoProdutos}
    setListaOrdemServicoProdutos={setListaOrcamentoServicoProdutos}
    removerProdutoCadastrado={removerProdutoCadastrado}
    setLoading={setLoading}
    ordemServico={orcamentoServico}
    ordemServicoEntity={orcamentoServicoEntity}
    buscarProdutosSimilares={buscarProdutosSimilares}
    produtosSimilares={produtosSimilares}
    setProdutosSimilares={setProdutosSimilares}
    produto={produto}
    setProduto={setProduto}
    meioPagamentoSelecionado={meioPagamentoSelecionado}
    acrescimoPagamento={acrescimoPagamento}
    tabelas={tabelas}
    setListaOrdemServicoPagamentos={setListaOrcamentoServicoPagamentos}
    vendedoresList={vendedoresList}
    setVendedoresList={setVendedoresList}
    usuariosList={usuariosList}
    configuracoes={configuracoes}
    permissaoAlterarVendedor={permissaoAlterarVendedor}
    permissaoAlterarValorProduto={permissaoAlterarValorProduto}
    isProdutoEdit={isProdutoEdit}
    setIsProdutoEdit={setIsProdutoEdit}
  />
);

export default OrcamentoServicoListaProdutos;
